export default ({ authGuard, guestGuard }) => [
    { path: '/', name: 'welcome', component: require('~/pages/welcome.vue') },
    { path: '/pricing', name: 'pricing', component: require('~/pages/pricing.vue') },
    { path: '/about', name: 'about', component: require('~/pages/about.vue') },

    // Authenticated routes.
    ...authGuard([
        { path: '/home', name: 'home', component: require('~/pages/home.vue') },
        {
            path: '/my', component: require('~/pages/user/dashboard.vue'), children:
            [
                { path: '', redirect: { name: 'user.profile' }},

                { path: 'gym/create', name: 'catalog.gym.create', component: require('~/pages/catalog/gym/create.vue') },
                { path: 'gym/edit/:id', name: 'catalog.gym.edit', component: require('~/pages/catalog/gym/edit.vue'), props: true },
                { path: 'gym/list', name: 'user.gyms.list', component: require('~/pages/user/gyms.vue') },
                { path: 'gym/view/:id', name: 'user.gyms.view', component: require('~/pages/catalog/gym/view.vue'), props: true},
                { path: 'profile', name: 'user.profile', component: require('~/pages/user/profile.vue') },
                { path: 'password', name: 'user.password', component: require('~/pages/user/password.vue') },

                { path: 'subscriptions', name: 'user.subscriptions', component: require('~/pages/subscriptions/list.vue') },
                { path: 'subscriptions/edit/:id', name: 'user.subscription.edit', component: require('~/pages/subscriptions/form.vue'), props: true},
                { path: 'subscriptions/create', name: 'user.subscription.create', component: require('~/pages/subscriptions/form.vue')}
            ]
        },

        {
            path: '/catalog', component: require('~/pages/catalog/index.vue'), children:
            [
                { path: '', name: 'catalog.index', component: require('~/pages/catalog/index.vue') },
                { path: 'gym/:id', name: 'catalog.gym.view', component: require('~/pages/catalog/gym/view.vue') }
            ]
        }

    ]),

    // Guest routes.
    ...guestGuard([
        { path: '/login', name: 'login', component: require('~/pages/auth/login.vue') },
        { path: '/register', name: 'register', component: require('~/pages/auth/register.vue') },
        { path: '/register/thanks', name: 'register.thanks', component: require('~/pages/auth/thanks.vue') },
        { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email.vue') },
        { path: '/password/reset/:token', name: 'password.reset', component: require('~/pages/auth/password/reset.vue') }
    ]),

    { path: '*', component: require('~/pages/errors/404.vue') }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js